import { useTranslation as useTranslationHook } from "react-i18next";
//NOTE : Facade hook to use the react-i18next hook
export const useTranslation = (): ReturnType<typeof useTranslationHook> => {
  return useTranslationHook();
};
